import {
  shipperTypesSelector,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import ConfigCheckbox, {
  onCheckboxLabelPropertyEnable,
} from './ConfigCheckbox.js'
import {
  AMAZON_SFP,
  SHIPPER_VENDORS,
} from '../../../common/constants/ShipperNames.js'
import {
  defaultValidLabelPropertiesFunc,
  EMPTY_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'
import {useSelector} from '../../../store.js'
import {includesAll, includesSome} from '../../../common/utils.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

const NOTIFY_BILL_TO_LABEL_PROPERTY = 'notify_bill_to'
const NOTIFY_SHIP_TO_LABEL_PROPERTY = 'notify_ship_to'
const VALID_SHIPPER_TYPES = SHIPPER_VENDORS.filter((s) => s !== AMAZON_SFP)
function notifyBillToLabelPropertiesFunc() {
  return [NOTIFY_BILL_TO_LABEL_PROPERTY]
}
function notifyShipToLabelPropertiesFunc() {
  return [NOTIFY_SHIP_TO_LABEL_PROPERTY]
}

export function BillToNotify() {
  const {labelInfoID, onChange, showBillTo = true} = useLabelConfigContext()
  const [propertySpecs] = BillToNotify.propertySpecList
  const [labelProperty] = propertySpecs.labelPropertiesFunc(null, labelInfoID)

  const shipperTypes = useSelector((state) =>
    shipperTypesSelector(state, {labelInfoID}),
  )

  const hide = !includesSome(VALID_SHIPPER_TYPES, shipperTypes)

  return (
    <ConfigCheckbox
      label="Notify Bill To"
      onChange={(checked) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: checked,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      hide={hide || !showBillTo}
    />
  )
}

BillToNotify.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: notifyBillToLabelPropertiesFunc,
    dependentPropertiesFunc: EMPTY_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
    onLabelPropertyEnable: onCheckboxLabelPropertyEnable,
  },
]

export function ShipToNotify() {
  const {labelInfoID, onChange} = useLabelConfigContext()
  const [propertySpecs] = ShipToNotify.propertySpecList
  const [labelProperty] = propertySpecs.labelPropertiesFunc(null, labelInfoID)

  return (
    <ConfigCheckbox
      label="Notify Ship To"
      onChange={(checked) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: checked,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

ShipToNotify.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: notifyShipToLabelPropertiesFunc,
    dependentPropertiesFunc: EMPTY_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
    onLabelPropertyEnable: onCheckboxLabelPropertyEnable,
  },
]

export function NotifyNotice() {
  const {labelInfoID, isSummary, isPickMode} = useLabelConfigContext()

  const shipperTypes = useSelector((state) =>
    shipperTypesSelector(state, {labelInfoID}),
  )

  const supportedByAllShippers = includesAll(VALID_SHIPPER_TYPES, shipperTypes)

  const hide =
    !includesSome(VALID_SHIPPER_TYPES, shipperTypes) ||
    supportedByAllShippers ||
    isPickMode ||
    isSummary

  if (hide) {
    return null
  }

  return (
    <li className="flex-item list__item--shipping-options">
      <small className="error">Not all carriers support notifications</small>
    </li>
  )
}
